import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Flex } from 'reflexbox/styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import MarektingIconAnvilAIInAction from '@anvilco-pkg/ui/components/MarketingIcon/MarektingIconAnvilAIInAction'

import theme from 'theme'
import media from 'media'

import UniversalLink from 'components/UniversalLink'
import { MAX_WIDTH } from 'components/Article'
import { normalizeAdditionalResource } from 'lib/content'

const Container = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => ['isOnSidebarContainer'].indexOf(prop) === -1,
  })
  .attrs(({ isOnSidebarContainer }) => ({
    maxWidth: isOnSidebarContainer
      ? ['100%', '100%', '100%', 170]
      : [MAX_WIDTH, MAX_WIDTH, 170],
    pt: [20],
    px: [20, 20, 0],
    pb: [60, 60, 20],
  }))`
  display: grid;
  grid-template-columns: 1fr;
  gap: 26px;
  flex: 1;
  margin-right: auto;
  margin-left: auto;
  padding: 20px;

  ${media.desktop`
    margin-right: unset;
  `}
`

const Label = styled(Box).attrs({
  fontSize: 12,
  lineHeight: 1.5,
  color: theme.colors.blacks[60],
})`
  text-transform: uppercase;
  letter-spacing: 2px;
`

const ResourceContent = styled(Flex)
  .withConfig({
    shouldForwardProp: (prop) => ['isOnSidebarContainer'].indexOf(prop) === -1,
  })
  .attrs(({ isOnSidebarContainer }) => ({
    flexDirection: [
      'row',
      'row',
      isOnSidebarContainer ? 'row' : 'column',
      'column',
    ],
  }))`
  gap: 12px;
`

const ResourceTitle = styled(Box).attrs({
  fontSize: 15,
  lineHeight: 1.5,
  fontWeight: theme.fontWeights.black,
})``

const ResourceDescription = styled(Box).attrs({
  fontSize: 15,
  lineHeight: 1.4,
  color: theme.colors.blacks[60],
})``

const StyledUniversalLink = styled(UniversalLink)`
  font-size: 15px;
  line-height: 1.5;
`

const ResourceImage = styled(GatsbyImage)`
  width: 60px;
  height: 60px;
  display: block;
`

const StyledMarektingIconAnvilAIInAction = styled(MarektingIconAnvilAIInAction)`
  width: 60px;
  height: 60px;
  display: block;
`

const ResourceWrapper = styled(Box)``

const Divider = styled(Box).attrs({
  height: '2px',
  width: '100%',
  backgroundColor: theme.colors.blacks[10],
  mb: '26px',
})``

const ResourceImageWrapper = styled(Box)`
  flex-shrink: 0;
`

const AdditionalResources = ({
  label = 'Dive Deeper',
  resources = [],
  isOnSidebarContainer = false,
}) => {
  return (
    <Container isOnSidebarContainer={isOnSidebarContainer}>
      <Label>{label}</Label>
      {resources.map((resource, index) => {
        const { description, imageData, linkText, title, to } =
          normalizeAdditionalResource(resource)
        return (
          <ResourceWrapper key={index}>
            {index !== 0 && <Divider />}
            <ResourceContent isOnSidebarContainer={isOnSidebarContainer}>
              <ResourceImageWrapper>
                {!imageData ? (
                  <StyledMarektingIconAnvilAIInAction />
                ) : (
                  <ResourceImage
                    alt={title}
                    image={getImage(imageData)}
                    style={{ width: 60, height: 60 }}
                  />
                )}
              </ResourceImageWrapper>
              <Box>
                <ResourceTitle>{title}</ResourceTitle>
                <ResourceDescription>{description}</ResourceDescription>
                <StyledUniversalLink to={to}>{linkText}</StyledUniversalLink>
              </Box>
            </ResourceContent>
          </ResourceWrapper>
        )
      })}
    </Container>
  )
}

AdditionalResources.propTypes = {
  label: PropTypes.string,
  resources: PropTypes.arrayOf(PropTypes.object),
  isOnSidebarContainer: PropTypes.bool,
}

export default AdditionalResources
